exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-slider-component/theme/antd.css"), "");

// module
exports.push([module.id, ".date-range-selector[data-v-61bbefb7] .vue-slider-process {\n  background-color: #667EEA;\n}\n.date-range-selector[data-v-61bbefb7] .vue-slider-dot-handle {\n  border-color: #A3BFFA;\n}", ""]);

// exports
